import { getAuth, onAuthStateChanged } from 'firebase/auth';
import axios from 'axios';

// Initialize token monitoring on app startup
export function initTokenMonitoring() {
  const auth = getAuth();
  
  // Monitor auth state changes to automatically update token
  onAuthStateChanged(auth, async (user) => {
    if (user) {
      await refreshAndStoreToken(user);
    } else {
      removeToken();
    }
  });
  
  // Set up a token refresh interval (Firebase tokens expire after 1 hour)
  const REFRESH_INTERVAL = 50 * 60 * 1000; // 50 minutes
  const refreshInterval = setInterval(async () => {
    const currentUser = auth.currentUser;
    if (currentUser) {
      await refreshAndStoreToken(currentUser);
    }
  }, REFRESH_INTERVAL);

  return () => clearInterval(refreshInterval); // Clear the interval on unmount
}

// Refresh token and store it
export async function refreshAndStoreToken(user) {
  try {
    const token = await user.getIdToken(true);
    localStorage.setItem('token', token);
    console.log("Token refreshed and stored");
    return token;
  } catch (error) {
    console.error("Error refreshing token:", error);
    return null;
  }
}

// Get current token from storage
export function getToken() {
  return localStorage.getItem('token');
}

// Set token with explicit value (used during login)
export function setToken(token) {
  if (!token) {
    console.warn("Attempted to set empty token");
    return;
  }
  
  localStorage.setItem('token', token);
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  console.log("Token set in both localStorage and axios headers");
}

// Remove token (used during logout)
export function removeToken() {
  localStorage.removeItem('token');
  delete axios.defaults.headers.common['Authorization'];
  console.log("Token removed from localStorage and axios headers");
}

// Force refresh token from Firebase
export async function refreshToken() {
  try {
    const auth = getAuth();
    const user = auth.currentUser;
    if (user) {
      const newToken = await user.getIdToken(true);
      setToken(newToken);
      return newToken;
    }
    return null;
  } catch (error) {
    console.error("Error refreshing token:", error);
    return null;
  }
}